/**
 * Route-to-import mapping for prefetch support.
 *
 * Extracted from `lazyPages.ts` so the `usePrefetch` hook (and downstream
 * `PrefetchLink`) can consume the map without pulling in every page's
 * `React.lazy` descriptor. That split breaks the static-import cycle
 * reported by madge: PrefetchLink -> usePrefetch -> lazyPages -> pages -> ...
 *
 * Maps route paths to their dynamic import functions so chunks can be
 * pre-loaded on hover/focus before navigation occurs.
 */
export const routePrefetchMap: Record<string, () => Promise<unknown>> = {
  "/dashboard": () => import("../pages/Dashboard"),
  "/meetups": () => import("../pages/Meetups"),
  "/meetups/new": () => import("../pages/CreateMeetup"),
  "/meetups/new/wizard": () => import("../pages/CreateMeetupWizard"),
  "/meetups/create": () => import("../pages/CreateMeetupWizard"),
  "/profile": () => import("../pages/Profile"),
  "/friends": () => import("../pages/Friends"),
  "/find-friends": () => import("../pages/FindFriends"),
  "/groups": () => import("../pages/Groups"),
  "/invitations": () => import("../pages/Invitations"),
  "/templates": () => import("../pages/Templates"),
  "/referrals": () => import("../pages/Referrals"),
  "/help": () => import("../pages/HelpCenter"),
  "/account": () => import("../pages/Account/index"),
  "/account/subscription": () =>
    import("../pages/Account/SubscriptionManagement"),
  "/account/security": () => import("../pages/Account/Security"),
  "/account/analytics": () => import("../pages/Account/Analytics"),
  "/notifications": () => import("../pages/NotificationSettings"),
  "/payment": () => import("../pages/PaymentPage"),
  // Public pages
  "/login": () => import("../pages/LoginPage"),
  "/register": () => import("../pages/RegisterPage"),
  "/how-it-works": () => import("../pages/HowItWorks"),
  "/features": () => import("../pages/Features"),
  "/pricing": () => import("../pages/Pricing"),
  "/about": () => import("../pages/About"),
  "/contact": () => import("../pages/Contact"),
  "/blog": () => import("../pages/Blog"),
  "/privacy": () => import("../pages/Privacy"),
  "/terms": () => import("../pages/Terms"),
};
